<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import * as tocbot from 'tocbot';
// Init TOCBot after content is processed
onMounted(() => {
  tocbot.init({
    tocSelector: '.js-toc',
    contentSelector: '.js-toc-content',
    headingSelector: 'h1, h2, h3, h4, h5, h6',
    // positionFixedSelector: '.js-toc',
    includeTitleTags: false,
    hasInnerContainers: false,
    collapseDepth: 6,
    scrollSmooth: true,
    enableUrlHashUpdateOnScroll: false,
    headingsOffset: 200,
    scrollSmoothOffset: -120,
    onClick: (e) => {
      e.preventDefault();
      const id = e.target.getAttribute('href')?.slice(1);
      if (id) {
        const el = document.getElementById(id);
        el?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });
});

onBeforeUnmount(() => {
  tocbot.destroy();
});
</script>

<template></template>
